import { Action } from '@/components/ActionCard';
import {
  CATEGORY_BALANCED,
  CATEGORY_LOCAL,
  CATEGORY_ORDER,
  CATEGORY_ZERO_WASTE,
} from '@/utils/scoring';
import BalancedMealIcon from '../assets/images/icons/balanced_meal.svg';
import CartIcon from '../assets/images/icons/cart.svg';
import CookerIcon from '../assets/images/icons/cooker.svg';
import LocalProductsIcon from '../assets/images/icons/local_products.svg';
import SoybeanIcon from '../assets/images/icons/soybean.svg';
import NutriScoreIcon from '../assets/images/icons/nutri_score.svg';
import PansIcon from '../assets/images/icons/pans.svg';
import RecyclableIcon from '../assets/images/icons/recyclable.svg';
import TrashIcon from '../assets/images/icons/trash.svg';

export {
  CATEGORY_BALANCED,
  CATEGORY_LOCAL,
  CATEGORY_ORDER,
  CATEGORY_ZERO_WASTE,
  LOTO_BONUS_POINTS,
} from '@/utils/scoring';

// i18n : les textes affichés vivent dans i18n/locales/*.json sous la racine
// `actions.<slug>.*` (slug stable par action). Rendu via t(action.nameKey).
// Les constantes CATEGORY_* restent des IDENTIFIANTS de logique (groupement,
// bonus) : pour AFFICHER un titre de catégorie, passer par CATEGORY_LABEL_KEYS.
export const CATEGORY_LABEL_KEYS: Record<string, string> = {
  [CATEGORY_LOCAL]: 'actions.categories.local',
  [CATEGORY_BALANCED]: 'actions.categories.balanced',
  [CATEGORY_ZERO_WASTE]: 'actions.categories.zeroWaste',
};

export const ACTIONS: Action[] = [
  {
    id: 7,
    nameKey: 'actions.grta.name',
    icon: LocalProductsIcon,
    descriptionKey: 'actions.grta.description',
    category: CATEGORY_LOCAL,
    points: 10,
    infoUrl: 'https://www.geneveterroir.ch/fr/vente',
    infoLabelKey: 'actions.grta.infoLabel',
  },
  {
    id: 8,
    nameKey: 'actions.ambassadeurs.name',
    icon: CookerIcon,
    descriptionKey: 'actions.ambassadeurs.description',
    category: CATEGORY_LOCAL,
    points: 30,
    infoUrl: 'https://www.geneveterroir.ch/fr/ambassadeurs-du-terroir/4547',
    infoLabelKey: 'actions.ambassadeurs.infoLabel',
  },
  {
    id: 9,
    nameKey: 'actions.venteFerme.name',
    icon: CartIcon,
    descriptionKey: 'actions.venteFerme.description',
    category: CATEGORY_LOCAL,
    points: 50,
    infoUrl: 'https://www.geneveterroir.ch/fr/points-de-vente-de-produits-du-terroir/4775',
    infoLabelKey: 'actions.venteFerme.infoLabel',
  },
  {
    id: 4,
    nameKey: 'actions.repasEquilibre.name',
    icon: BalancedMealIcon,
    descriptionKey: 'actions.repasEquilibre.description',
    category: CATEGORY_BALANCED,
    points: 10,
    infoUrl: 'https://www.sge-ssn.ch/fr/recommandations/recommandations-officielles/recommandations-nutritionnelles/',
    infoLabelKey: 'actions.repasEquilibre.infoLabel',
  },
  {
    id: 6,
    nameKey: 'actions.nutriScore.name',
    icon: NutriScoreIcon,
    descriptionKey: 'actions.nutriScore.description',
    category: CATEGORY_BALANCED,
    points: 30,
    infoUrl: 'https://www.blv.admin.ch/nutri-score-fr',
    infoLabelKey: 'actions.nutriScore.infoLabel',
  },
  {
    id: 5,
    nameKey: 'actions.proteineVegetale.name',
    icon: SoybeanIcon,
    descriptionKey: 'actions.proteineVegetale.description',
    category: CATEGORY_BALANCED,
    points: 50,
    infoUrl: 'https://www.fourchetteverte-ge.ch/astuces-alimentaires/',
    infoLabelKey: 'actions.proteineVegetale.infoLabel',
  },
  {
    id: 1,
    nameKey: 'actions.contenantReutilisable.name',
    icon: PansIcon,
    descriptionKey: 'actions.contenantReutilisable.description',
    category: CATEGORY_ZERO_WASTE,
    points: 10,
    infoUrl: 'https://www.ge.ch/teaser/emportons-malin',
    infoLabelKey: 'actions.contenantReutilisable.infoLabel',
  },
  {
    id: 2,
    nameKey: 'actions.compost.name',
    icon: RecyclableIcon,
    descriptionKey: 'actions.compost.description',
    category: CATEGORY_ZERO_WASTE,
    points: 30,
    infoUrl: 'https://www.ge.ch/teaser/p-tite-poubelle-verte',
    infoLabelKey: 'actions.compost.infoLabel',
  },
  {
    id: 3,
    nameKey: 'actions.pasDeGaspillage.name',
    icon: TrashIcon,
    descriptionKey: 'actions.pasDeGaspillage.description',
    category: CATEGORY_ZERO_WASTE,
    points: 50,
    infoUrl: 'https://www.ge.ch/teaser/gaspillage-alimentaire',
    infoLabelKey: 'actions.pasDeGaspillage.infoLabel',
  },
];

export const ALL_ACTION_IDS: number[] = ACTIONS.map((a) => a.id);

export function getActionsByCategory(): Record<string, Action[]> {
  const grouped: Record<string, Action[]> = {};
  for (const category of CATEGORY_ORDER) {
    grouped[category] = ACTIONS.filter((a) => a.category === category);
  }
  return grouped;
}
